import { employeeInputValue } from '../employeeInputValidation';
export default function EmploymentDetailsStep({
  formData,
  setFormData,
  branches,
  departments,
  designations,
  roles,
}) {
  const handleChange = (event) => {
    const { name, value, checked, type } = event.target;

    setFormData((previous) => {
      if (name === "department") {
        return {
          ...previous,
          department: value,
          designation: "",
        };
      }

      if (name === "grantErpAccess") {
        return {
          ...previous,
          grantErpAccess: checked,
          erpRoleIds: checked ? previous.erpRoleIds : [],
        };
      }

      if (name === "erpRoleIds") {
        return {
          ...previous,
          erpRoleIds: Array.from(
            event.target.selectedOptions,
            (option) => option.value,
          ),
        };
      }

      return {
        ...previous,
        [name]: type === "checkbox" ? checked : employeeInputValue(name, value, previous[name]),
      };
    });
  };

  const employmentTypes = ["Permanent", "Contract", "Intern", "Temporary"];

  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-6">
          Employment Details
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="rounded-2xl border border-primary-100 bg-primary-50 p-4">
            <p className="text-sm font-semibold text-primary-800">
              Employee Code (Prefix- C1)
            </p>

            <p className="mt-1 text-sm text-primary-700">
              Generated automatically by the system after employee creation.
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Department
            </label>

            <select
              name="department"
              value={formData.department}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-red-800"
            >
              <option value="">Select Department</option>

              {departments.map((department) => (
                <option key={department.id} value={department.id}>
                  {department.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Designation
            </label>

            <select
              name="designation"
              value={formData.designation}
              onChange={handleChange}
              disabled={!formData.department}
              className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-red-800 disabled:bg-gray-50 disabled:text-gray-400"
            >
              <option value="">
                {formData.department
                  ? "Select Designation"
                  : "Select a department first"}
              </option>

              {designations.map((designation) => (
                <option key={designation.id} value={designation.id}>
                  {designation.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Branch
            </label>

            <select
              name="branch"
              value={formData.branch}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-red-800"
            >
              <option value="">Select Branch</option>

              {branches
                .filter((branch) => branch.isActive)
                .map((branch) => (
                  <option key={branch.id} value={branch.id}>
                    {branch.name}
                  </option>
                ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Joining Date
            </label>

            <input
              type="date"
              name="joiningDate"
              aria-label="Joining date"
              min="0001-01-01"
              max="9999-12-31"
              value={formData.joiningDate}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-red-800"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Employment Type
            </label>

            <select
              name="employmentType"
              value={formData.employmentType}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-red-800"
            >
              <option value="">Select Employment Type</option>

              {employmentTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-100 pt-8">
        <div className="flex items-start gap-3">
          <input
            id="grantErpAccess"
            type="checkbox"
            name="grantErpAccess"
            checked={formData.grantErpAccess}
            onChange={handleChange}
            className="mt-1 h-4 w-4 accent-primary-700"
          />

          <div>
            <label
              htmlFor="grantErpAccess"
              className="text-sm font-semibold text-gray-800"
            >
              Give ERP dashboard access
            </label>

            <p className="mt-1 text-xs text-gray-500">
              All employees get mobile self-service access automatically. Enable
              this only for employees who need the ERP dashboard.
            </p>
          </div>
        </div>

        {formData.grantErpAccess && (
          <div className="mt-5">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              ERP Roles
            </label>

            <select
              multiple
              name="erpRoleIds"
              value={formData.erpRoleIds}
              onChange={handleChange}
              className="w-full min-h-36 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-red-800"
            >
              {roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.name} ({role.code})
                </option>
              ))}
            </select>

            <p className="mt-2 text-xs text-gray-400">
              Hold Command on Mac or Control on Windows to select multiple
              roles.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
